import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    violation: (type: uui.domain.rm.RouteViolationsType) => {
      switch (type) {
        case 'LD':
          return translate({ id: 'rm.scheduler.violations.vehicle.maxLoad' })
        case 'TWS':
          return translate({ id: 'rm.scheduler.violations.vehicle.twStart' })
        case 'TWE':
          return translate({ id: 'rm.scheduler.violations.vehicle.twEnd' })
        case 'DT':
          return translate({ id: 'rm.scheduler.violations.vehicle.drivingTime' })
        case 'WT':
          return translate({ id: 'rm.scheduler.violations.vehicle.workingTime' })
        case 'ML':
          return translate({ id: 'rm.scheduler.violations.vehicle.maxMileage' })
        case 'OR':
          return translate({ id: 'rm.scheduler.violations.vehicle.maxOrders' })
        case 'ST':
          return translate({ id: 'rm.scheduler.violations.vehicle.maxStops' })
        case 'LO':
          return translate({ id: 'rm.scheduler.violations.vehicle.maxLocations' })
        case 'NLD':
          return translate({ id: 'rm.scheduler.violations.vehicle.negativeLoadValue' })
      }
    },
  }))

  return api
}
